import React from 'react';
import styled from "styled-components";
import FilterActionReset from "../FilterActionReset";

const StyledNotResult = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
`

interface IProps {
    onResetFilters: () => void;
}

const FilterNotResult: React.FC<IProps> = ({onResetFilters}) => {
    return (
        <StyledNotResult>
            <h2 className={"result-find"}>По запросу ничего не найдено.</h2>
            <FilterActionReset onResetFilters={onResetFilters}/>
        </StyledNotResult>
    );
};

export default FilterNotResult;